const FETCH_BIDS_REQUEST = 'FETCH_BIDS_REQUEST'
const FETCH_BIDS_SUCCESS = 'FETCH_BIDS_SUCCESS'
const FETCH_BIDS_FAILURE = 'FETCH_BIDS_FAILURE'


export const bidsActionTypes = {
  FETCH_BIDS_REQUEST,
  FETCH_BIDS_SUCCESS,
  FETCH_BIDS_FAILURE,
}
